<template>
  <footer :class="$props.from">
    <div class="wrap">
      <div class="logined" style="padding-left:2px" v-if="!_.isEmpty(userInfo) && userInfo.token">
        <Row type="flex" justify="space-around" class="code-row-bg">
          <Col :span="6">
            <div class="item">
              <div class="title">{{$t('footer.friendship')}}</div>
              <ul>
                <li class="ellipsis" v-for="(item, index) in links" :key="`fl-${index}`">
                  <a :href="item.url" target="_blank" class="line2">{{item.name || item.title}}</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col :span="7">
            <div class="item">
              <div class="title">{{$t('nav.about')}}</div>
              <ul>
                <li class="ellipsis">
                  <router-link :to="{name: 'About'}" class="line2">{{$t('slogen.title')}}</router-link>
                </li>
              </ul>
            </div>
          </Col>
          <Col :span="4">
            <div class="item">
              <div class="title">{{$t('footer.contact')}}</div>
              <ul class="contact">
                <li class="ellipsis tel">400-099-9825</li>
                <li class="ellipsis email">info@otechsolution.com</li>
              </ul>
            </div>
          </Col>
        </Row>
        <div class="copyright"><p v-html="$t('footer.copyright')"></p></div>
      </div>
      <div style="padding-left:2px" v-else>
        <Row :gutter="rowSpace">
          <Col :span="colNum[0]">
            <div class="item">
              <div class="title">{{$t('footer.friendship')}}</div>
              <ul>
                <li class="ellipsis" v-for="(item, index) in links" :key="`fl-${index}`">
                  <a :href="item.url" target="_blank" class="line2">{{item.name || item.title}}</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col :span="colNum[1]">
            <div class="item">
              <div class="title">{{$t('nav.laws')}}</div>
              <ul>
                <li class="ellipsis" v-for="(item, index) in categoryList" :key="`law-${index}`">
                  <router-link class="line2" :to="{name: 'Laws', query: {cid: item.id}}">{{item.name}}</router-link>
                </li>
              </ul>
            </div>
          </Col>
          <Col :span="colNum[2]">
            <div class="item">
              <div class="title">{{$t('nav.about')}}</div>
              <ul class="contact">
                <li class="ellipsis">
                  <router-link :to="{name: 'About'}" class="line2">{{$t('slogen.title')}}</router-link>
                </li>
                <li class="ellipsis tel">400-099-9825</li>
                <li class="ellipsis email">info@otechsolution.com</li>
              </ul>
            </div>
          </Col>
          <Col :span="colNum[3]">
            <div :class="['item', {[$style.footerAccountDefalut]: $props.from !== 'home'}]">
              <div class="title">{{$t('nav.account')}}</div>
              <div class="gobtn" @click.prevent="isShow(true)">
                <span>{{$t('footer.goTip')}}</span>
                <div class="go">{{$t('footer.goName')}}</div>
              </div>
            </div>
          </Col>
        </Row>
        <div class="copyright"><p v-html="$t('footer.copyright')"></p></div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapMutations, createNamespacedHelpers } from 'vuex'
import ATag from '@/components/common/ATag'
const { mapState: mapDataState } = createNamespacedHelpers('data')
const { mapState: mapAccountState } = createNamespacedHelpers('account')

export default {
  name: 'Footer',
  components: { ATag },
  props: {
    from: {
      type: String,
      default: 'default',
      required: false
    }
  },
  data () {
    return {
      colNum: this.$props.from === 'home' ? [6, 6, 5, 7] : [6, 6, 5, 7],
      rowSpace: this.$props.from === 'home' ? 15 : 35
    }
  },
  computed: {
    ...mapAccountState({
      userInfo: state => state.userInfo
    }),
    ...mapDataState({
      links: state => state.links,
      categoryList (state) {
        return this._.filter(state.categoryAll, (v) => v.type === 2)
      }
    })
  },
  methods: {
    ...mapMutations({
      isShow: 'account/setModalState'
    })
  }
}
</script>
<style scoped>
  footer{
    padding: 54px 0 30px;
  }
  footer .item{
    position: relative;
  }
  footer .title{
    color: var(--homeTitleColor);
    font-size: 1.4rem;
    margin-bottom: 12px;
  }
  footer a{
    color: #99A8C1;
    font-size: 1.3rem;
  }
  footer a:hover{
    color: #99A8C1;
  }
  footer a:after{
    background-color: #99A8C1;
  }
  .ie footer a[class~="router-link-active"],
  .ie footer a[class~="router-link-exact-active"]{
    box-shadow: none;
  }
  .ie footer a[class~="router-link-active"]:hover,
  .ie footer a[class~="router-link-exact-active"]:hover{
    box-shadow: 0 1px;
  }
  ul li{
    margin-bottom: 5px;
    padding-bottom: 3px;
  }
  .gobtn{
    background-color: #fff;
    border: 0.5px solid #D0D7E3;
    cursor: pointer;
    height: 32px;
    line-height: 30px;
    padding-left: 10px;
    position: relative;
  }
  .gobtn span{
    color: #99A8C1;
    font-size: 1.2rem;
  }
  .gobtn .go{
    background-color: #99A8C1;
    color: #fff;
    position: absolute;
    width: 36px;
    top:0px;
    bottom: 0px;
    right: 0;
    font-size: 13px;
    text-align: center;
  }
  footer >>> ul.share{
    position: absolute;
    right: 0;
  }
  .copyright{
    color: #99A8C1;
    font-size: 1.3rem;
    margin-top: 15px;
    padding-top: 20px;
    border-top: 0.5px solid#EBEBEB;
  }
  /*default footer*/
  footer{
    /* background-color: #F8F8F8 !important;
    padding-top: 20px !important; */
    background-color: #F8F8F8;
  }
  footer .wrap{
    width: var(--contentPageWidth);
    margin: 0 auto;
    max-width: var(--contentPageMaxWidth);
  }
  /*home footer*/
  footer.home{
    background-color: var(--homeBGGrey);
  }
  footer.home .wrap{
    width: var(--homeContentWidth);
    max-width: var(--homeContentMaxWidth);
  }
  /*login in footer*/
  footer .logined >>> ul.share{
    position: static;
  }
  footer .logined >>> ul.share li{
    margin-top: 0;
  }
  footer .logined >>> ul.share li:first-child{
    margin-left: 0;
  }
  .contact{
    font-size: 1.3rem;
    color: #99A8C1;
  }
  .contact li.tel,
  .contact li.email{
    background: url("~@/assets/images/icons/tel.png") 0 center no-repeat transparent;
    padding-left: 20px;
    padding-bottom: 0;
  }
  .contact li.email{
    background-image: url("~@/assets/images/icons/mail.png");
    background-size: 13px auto;
  }
</style>
<style module>
  .footerAccountDefalut{
    width: 50%;
    position: absolute !important;
    right: 0;
    min-width: 276px;
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue